




import { mapGetters, mapState } from 'vuex'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { App, User } from '@/services/types'

@Component({
  computed: {
    ...mapGetters('auth', { user: 'getUser' }),
    ...mapGetters('app', { apps: 'getApps', app: 'getSelectedApp' }),
    ...mapState('app', ['showMenu'])
  }
})
export default class Builder extends Vue {
  loaded = false
  user!: User
  apps!: App[]
  appsLoaded = this.apps !== null
  app!: App

  @Watch('$route.params.id', { immediate: true })
  async onRouteIdParamChange(id: string | null): Promise<void> {
    if (!this.user) {
      await this.$router.push({ name: '404' })
    }

    if (!id) {
      this.loaded = false
      await this.$store.dispatch('builder/setApp', null)
    }

    if (!this.appsLoaded) {
      await this.$store.dispatch('app/fetchApps')
      if (!this.app) {
        await this.$store.dispatch('apps/selectApp', { app: this.apps[0]})
      }
    }

    this.loaded = true
  }
  scrollPosition = 0
  @Watch('showMenu', { immediate: true })
  setOverflowBody(val) {
    if (this.$breakpoints.mobileSmall) {
      if (val) {
        this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop
        document.body.style.top = '-' + this.scrollPosition + 'px'
        document.body.classList.add('fixed')
      } else {
        document.body.classList.remove('fixed')
        window.scroll(0, this.scrollPosition)
      }
    }
  }
}
